import { SET_LOGO } from '../../mutation-types';
import { getCurrentLogoPathsByName } from './utils';

export function setCurrentLogo({ commit }, { name }) {
    commit(SET_LOGO, { currentLogo: getCurrentLogoPathsByName(name), name });
}
